import { clearCustomer } from "../Customer";
import { logout } from "ccui-framework";
import { getCustomer } from "../Customer";
import { setLoginError } from "./action";
import {
  HIDE_SESSION_EXPIRE_WARNING,
  HIDE_SESSION_EXPIRED,
} from "../../constants/actionTypes";

export const signOut =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      await remote(
        "delete",
        `/v3/customers/logout`,
        {},
        "logging customer out",
        dispatch
      );

      await dispatch(logout());
      dispatch(clearCustomer());
      await dispatch(createSession());
      history.push("/");
    } catch (error) {}
  };

export const createSession =
  () =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const session = await remote(
        "post",
        "/v3/session",
        {},
        "creating a session",
        dispatch
      );

      if (session.message) {
        throw session;
      }

      dispatch({ type: HIDE_SESSION_EXPIRE_WARNING });
      dispatch({ type: HIDE_SESSION_EXPIRED });

      await dispatch(getCustomer());
    } catch (e) {
      console.log("error", e);
    }
  };

export const loginUser =
  (email, password) =>
  async (dispatch, getState, { history, remote }) => {
    try {
      const loginUser = await remote(
        "post",
        `/v3/customers/login`,
        { customer: { email, password } },
        "logging in a user",
        dispatch
      );

      if (loginUser.message) {
        throw loginUser;
      }

      await dispatch(getCustomer());

      history.push(
        history?.location?.state?.referrer === "/quick-sell"
          ? "/quick-sell"
          : "/new-order/enter-cards"
      );
    } catch (error) {
      const errMsg =
        error.message[0] === "reCaptcha required" ||
        error.message[0] === "customer account is locked"
          ? "Customer account is locked. Please contact customer service"
          : "Invalid Email/Password";

      dispatch(setLoginError(errMsg || error.message[0]));
    }
  };
